export default class LoginHintStore {
  private static readonly CookieName: string = 'ssoLoginHintValue';

  public getLoginHint(): string | undefined {
    return this.getCookieValue(LoginHintStore.CookieName);
  }

  public setLoginHint(value: string) {
    this.setCookieValue(LoginHintStore.CookieName, value, 29);
  }

  private setCookieValue(name: string, value: string, days?: number) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  private getCookieValue(name: string): string | undefined {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (const cookie of ca) {
      const c = cookie.trim();
      if (c.startsWith(nameEQ)) {
        return c.substring(nameEQ.length);
      }
    }
    return undefined;
  }
}
